import SettingTimesheetProject from "../components/SettingTimesheetProject";
import useSettingTimeSheetProject from "../hooks/useSettingTimeSheetProject";

const SettingTimesheetProjectPage = () => {
    const props = useSettingTimeSheetProject()
    return (
        <SettingTimesheetProject {...props} />
    )
}

export default SettingTimesheetProjectPage;